export async function accountFetch(
  accountId: string | undefined,
  path: string,
  options: RequestInit = {},
) {
  const headers = new Headers(options.headers);
  if (accountId) headers.set('X-Pons-Account', accountId);
  const response = await fetch(path, { ...options, headers });
  if (response.status === 401 && accountId)
    window.dispatchEvent(
      new CustomEvent('pons:session-expired', { detail: accountId }),
    );
  if (
    typeof window !== 'undefined' &&
    response.ok &&
    options.method === 'POST' &&
    (path === '/api/predictions' || path === '/api/game/predictions')
  )
    window.dispatchEvent?.(new Event('pons:points-changed'));
  return response;
}
